import { IReportState } from "./interfaces";

export function watchReportChanges(first: IReportState, second: IReportState): boolean {
	return (
		JSON.stringify(first.data) === JSON.stringify(second.data)
	);
}
